// Shared API configuration
// All API calls should use this base URL

export const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:5005/api/v1';

// WebSocket URL (derived from API URL)
export const getWebSocketUrl = (path: string = '') => {
    const apiUrl = API_BASE_URL.replace('/api/v1', '');
    const wsUrl = apiUrl.replace('https://', 'wss://').replace('http://', 'ws://');
    return `${wsUrl}${path}`;
};

export const WS_BASE_URL = getWebSocketUrl('/ws');
